export const CompanyDealer = {
  company: 167,
  dealer: 292,
  dealerName: "Hyundai",
};
